import { Box, Modal } from '@mui/material';
import * as React from 'react';
import { useAppSelector } from '../../../../redux/root';
import { Countable } from '../../../../types';
import { modalStyles } from '../../../../utils/constants';
import CloseModalIcon from '../../../common/Common';
import { ItemCountTable, useItemsCount } from './KhassidaModal';

type AzkaarModalProps = {
  show: boolean;
  onHide: () => void;
  data: Countable[];
};

const AzkaarModal = ({ show, onHide, data }: AzkaarModalProps) => {
  const khassida = useAppSelector((s) => s.azkaar);
  const filtred = React.useMemo(() => {
    return data.filter((d) => d.azkaar);
  }, [data]);
  const items = useItemsCount(filtred, khassida);

  return (
    <Modal
      open={show}
      onClose={onHide}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={modalStyles}>
        <CloseModalIcon {...{ onHide }} />
        <ItemCountTable title="Azkaar" items={items} />
      </Box>
    </Modal>
  );
};

export default AzkaarModal;
